/*
 * @Descripttion: 
 * @version: 
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-06-10 09:21:12
 * @LastEditors: sj
 * @LastEditTime: 2022-08-19 15:02:18
 */
import { Col } from "antd"
import React, { useEffect, useState } from "react"
import { TabBar, TabPane } from "../../compnents/widgets/TabBar"
import styles from "./outRecipe.module.css"
import OutRecipe from "./outRecipe"
import OutRecipeWaitUpload from "./outRecipeWaitUpload";
import { useLocation } from "react-router-dom"

export const InsuranceOutRecipeTabbar = () => {
  const location = useLocation<any>()

  const [currentTab, setCurrentTab] = useState<any>('1')

  const [backSelectKey, setBackSelectKey] = useState<any>()

  const selectKey = location?.state?.backSelectTab

  useEffect(() => {
    setBackSelectKey(selectKey)
  }, [selectKey])

  return (
    <Col className={styles.container}>
      <TabBar
        activeKey={backSelectKey ? backSelectKey : currentTab}
        defaultActiveKey={backSelectKey ? backSelectKey : currentTab}
        onChange={((v)=>{
          setBackSelectKey(undefined)
          setCurrentTab(v)
        })}
      >
        <TabPane key='1' tab='外配处方上传记录'>
          <OutRecipe />
        </TabPane>
        <TabPane key='2' tab='待上传外配处方'>
          <OutRecipeWaitUpload />
        </TabPane>
      </TabBar>
    </Col>
  );
}
